import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Typography } from '@mui/material';
import CalendarIcon from 'Icons/calendar/hours/calendar.svg';
import CalendarIconWhite from 'Icons/calendar/hours/calendar_white.svg';
import HoursIconWhite from 'Icons/calendar/hours/hours_white.svg';
import HoursIcon from 'Icons/calendar/hours/hours.svg';
import PaymentHistoryIcon from 'Icons/calendar/hours/payment_history.svg';
import PaymentHistoryIconWhite from 'Icons/calendar/hours/payment_history_white.svg';

import { HomeLinkRoutes } from 'constants/routes';
import { useAuth } from 'utils/AuthProvider';
import strings from 'constants/strings';
import { handleErrorToast } from 'components/Toast';
import { useMedicalView } from 'utils/MedicalViewProvider';

const styles = {
  container: {
    width: 96,
    minWidth: 96,
  },
  button: {
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
  },
  buttonSelected: {
    borderRadius: 8,
    backgroundColor: 'rgb(4, 207, 192)',
  },
  icon: {
    width: 32,
    height: 32,
    padding: 0,
  },
};
export const MedicalSideBar = () => {
  const { acceptedTerms } = useAuth();
  const navigate = useNavigate();
  const {
    isSelectedAppointments,
    isSelectedScheduleView,
    isSelectedPaymentHistoryView,
  } = useMedicalView();

  const redirectToAppointmentsView = () => {
    if (acceptedTerms) {
      navigate(HomeLinkRoutes.medicalAppointments);
    } else {
      handleErrorToast('', strings.error.please_accept_terms);
      navigate(HomeLinkRoutes.patientProfileInfoInitial);
    }
  };

  const redirectToScheduleView = () => {
    if (acceptedTerms) {
      navigate(HomeLinkRoutes.medicalSchedule);
    } else {
      handleErrorToast('', strings.error.please_accept_terms);
      navigate(HomeLinkRoutes.patientProfileInfoInitial);
    }
  };

  const redirectToPaymentHistoryView = () => {
    if (acceptedTerms) {
      navigate(HomeLinkRoutes.medicalPaymentHistory);
    } else {
      handleErrorToast('', strings.error.please_accept_terms);
      navigate(HomeLinkRoutes.patientProfileInfoInitial);
    }
  };

  return (
    <div
      className={'flex flexColumn flexAlignCenter fullHeight bgColor--c-menu'}
      style={styles.container}
    >
      <IconButton
        className={`m16t`}
        onClick={redirectToAppointmentsView}
        style={isSelectedAppointments ? styles.buttonSelected : styles.button}
      >
        <img
          style={styles.icon}
          src={isSelectedAppointments ? CalendarIconWhite : CalendarIcon}
        />
      </IconButton>
      <Typography className={'m4t m16b color--green'}>予約一覧</Typography>
      <IconButton
        className={`m16t`}
        onClick={redirectToScheduleView}
        style={isSelectedScheduleView ? styles.buttonSelected : styles.button}
      >
        <img
          style={styles.icon}
          src={isSelectedScheduleView ? HoursIconWhite : HoursIcon}
        />
      </IconButton>
      <Typography className={'m4t m16b m16b color--green'}>営業時間</Typography>
      <IconButton
        className={`m16t`}
        onClick={redirectToPaymentHistoryView}
        style={
          isSelectedPaymentHistoryView ? styles.buttonSelected : styles.button
        }
      >
        <img
          style={styles.icon}
          src={
            isSelectedPaymentHistoryView
              ? PaymentHistoryIconWhite
              : PaymentHistoryIcon
          }
        />
      </IconButton>
      <Typography className={'m4t m16b color--green'}>支払履歴</Typography>
    </div>
  );
};
